<template>
  <div>
    <div v-if="problem.questionType != 6 && problem.questionType != 7">
      <div class="problemTitle font16 mgb20">
        <span>{{ index + 1 }}、</span>
        <div v-html="smartFixHtml(problem.questionTitle)" />
      </div>
      <div v-if="problem.questionType == 1 || problem.questionType == 3">
        <template v-if="isAnalysis || problem.show">
          <div v-for="(o, oIndex) in problem.optionList" :key="oIndex" class="oList">
            <div class="item_status">
              <img v-if="o.oStatus == 1" class="icon_status" src="@/assets/paper/circle_correct.svg" />
              <img v-if="o.oStatus == 2" class="icon_status" src="@/assets/paper/circle_wrong.svg" />
              <img v-if="o.oStatus == 3" class="icon_status" src="@/assets/paper/circle_default.svg" />
            </div>
            <span v-if="problem.questionType == 1" class="letters font16">{{ map.letter[oIndex] }}、</span>
            <div class="optionContent font16" v-html="smartFixHtml(o.optionContent)" />
          </div>
        </template>
        <template v-else>
          <el-radio-group v-model="map.value" class="radios_group" @change="radioChange">
            <div v-for="(o, oIndex) in problem.optionList" :key="oIndex" class="answer_radio">
              <el-radio :label="o.id">
                <div class="radio_item">
                  <div v-if="problem.questionType == 1" class="letters font16">
                    {{ map.letter[oIndex] }}、
                  </div>
                  <div v-html="smartFixHtml(o.optionContent)" />
                </div>
              </el-radio>
            </div>
          </el-radio-group>
        </template>
      </div>
      <div v-if="problem.questionType == 2">
        <template v-if="isAnalysis || problem.show">
          <div v-for="(o, oIndex) in problem.optionList" :key="oIndex" class="oList">
            <div class="item_status">
              <img v-if="o.oStatus == 1" class="icon_status" src="@/assets/paper/square_correct.svg" />
              <img v-if="o.oStatus == 2" class="icon_status" src="@/assets/paper/square_wrong.svg" />
              <img v-if="o.oStatus == 3" class="icon_status" src="@/assets/paper/square_default.svg" />
            </div>
            <span class="letters font16">{{ map.letter[oIndex] }}、</span>
            <div class="optionContent font16" v-html="o.optionContent" />
          </div>
        </template>
        <template v-else>
          <el-checkbox-group v-model="map.valueList" @change="checkboxChange">
            <div v-for="(o, oIndex) in problem.optionList" :key="oIndex" class="answer_checkbox">
              <el-checkbox :label="o.id">
                <div class="checkbox_item">
                  <div class="letters font16">{{ map.letter[oIndex] }}、</div>
                  <div v-html="o.optionContent" />
                </div>
              </el-checkbox>
            </div>
          </el-checkbox-group>
          <el-button v-if="isShowConfirm" color="#2256F6" style="color: white"
            :style="submitStatus ? { opacity: '0.8' } : { opacity: '1' }" size="large" @click="submit">
            提交
          </el-button>
        </template>
      </div>
      <div v-if="problem.questionType == 4 && !isAnalysis && !problem.show">
        <el-input v-for="oIndex in problem.optionCount" :key="oIndex" v-model="map.valueList[oIndex - 1]"
          :placeholder="'请输入第' + oIndex + '个空的答案'" style="margin-bottom: 10px" size="large" @blur="handleSaveProblem" />
        <el-button v-if="isShowConfirm" color="#2256F6" style="color: white" size="large"
          :style="submitStatus ? { opacity: '0.8' } : { opacity: '1' }" @click="radioChange(-1)">
          提交
        </el-button>
      </div>
      <div v-if="problem.questionType == 5 && !isAnalysis && !problem.show">
        <el-input v-model="map.value" color="#2256F6" type="textarea" placeholder="请输入答案" class="mgb10" resize="none"
          :rows="7" @blur="handleSaveProblem" />
        <el-button v-if="isShowConfirm" color="#2256F6" style="color: white" size="large"
          :style="submitStatus ? { opacity: '0.8' } : { opacity: '1' }" @click="radioChange(-1)">
          提交
        </el-button>
      </div>
    </div>
    <div v-if="problem.questionType == 6">
      <div class="problemTitle6 font16 mgb20">
        <span>{{ index + 1 }}、</span>
        <div v-html="problem.questionTitle" />
      </div>
      <div class="problemItem6" v-if="problem.isShow == 1">
        <div v-for="(i, index) in problem.adminSubQuestionResps" :key="index" class="qusitionStyle6">
          <div v-if="i.questionType == 1">
            <div class="problemTitleZi font16 mgb10">
              <span>({{ index + 1 }})、</span>
              <div v-html="i.questionTitle" />
            </div>
            <template v-if="isAnalysis">
              <div v-for="(o, oIndex) in i.optionList" :key="oIndex" class="oList6">
                <div class="item_status">
                  <img v-if="o.oStatus == 1" class="icon_status" src="@/assets/paper/circle_correct.svg" />
                  <img v-if="o.oStatus == 2" class="icon_status" src="@/assets/paper/circle_wrong.svg" />
                  <img v-if="o.oStatus == 3" class="icon_status" src="@/assets/paper/circle_default.svg" />
                </div>
                <span v-if="i.questionType == 1" class="letters font16">{{ map.letter[oIndex] }}、</span>
                <div class="optionContent font16" v-html="o.optionContent" />
              </div>
            </template>
            <template v-else>
              <el-radio-group v-model="map.value1[index]" class="radios_group6" @change="
                radioChange1(map.value1[index], index, i.questionType, i.questionId)
                ">
                <div v-for="(o, oIndex) in i.optionList" :key="oIndex" class="answer_radio">
                  <el-radio :label="o.id">
                    <div class="radio_item">
                      <div v-if="i.questionType == 1" class="letters font16">
                        {{ map.letter[oIndex] }}、
                      </div>
                      <div v-html="o.optionContent" />
                    </div>
                  </el-radio>
                </div>
              </el-radio-group>
            </template>
          </div>
          <div v-if="i.questionType == 2">
            <div class="problemTitleZi font16 mgb10">
              <span>({{ index + 1 }})、</span>
              <div v-html="i.questionTitle" />
            </div>
            <template v-if="isAnalysis">
              <div v-for="(o, oIndex) in i.optionList" :key="oIndex" class="oList6">
                <div class="item_status">
                  <img v-if="o.oStatus == 1" class="icon_status" src="@/assets/paper/square_correct.svg" />
                  <img v-if="o.oStatus == 2" class="icon_status" src="@/assets/paper/square_wrong.svg" />
                  <img v-if="o.oStatus == 3" class="icon_status" src="@/assets/paper/square_default.svg" />
                </div>
                <span class="letters font16">{{ map.letter[oIndex] }}、</span>
                <div class="optionContent font16" v-html="o.optionContent" />
              </div>
            </template>
            <template v-else>
              <el-checkbox-group v-model="map.valueList" @change="
                checkboxChange1(map.valueList, index, i.questionType, i.questionId)
                ">
                <div v-for="(o, oIndex) in i.optionList" :key="oIndex" class="answer_checkbox6">
                  <el-checkbox :label="o.id">
                    <div class="checkbox_item">
                      <div class="letters font16">{{ map.letter[oIndex] }}、</div>
                      <div v-html="o.optionContent" />
                    </div>
                  </el-checkbox>
                </div>
              </el-checkbox-group>
              <el-button v-if="isShowConfirm" color="#2256F6" style="color: white" size="large"
                :style="submitStatus ? { opacity: '0.8' } : { opacity: '1' }" @click="submit">
                提交
              </el-button>
            </template>
          </div>
        </div>
      </div>
      <div>
        <div v-for="(i, index) in problem.adminSubQuestionResps" :key="index" class="qusitionStyle6">
          <div v-if="i.questionType == 3">
            <div class="problemTitleZi font16 mgb10">
              <span>({{ index + 1 }})、</span>
              <div v-html="i.questionTitle" />
            </div>
            <template v-if="isAnalysis || i.show">
              <div v-for="(o, oIndex) in i.optionList" :key="oIndex" class="oList6">
                <div class="item_status">
                  <img v-if="o.oStatus == 1" class="icon_status" src="@/assets/paper/circle_correct.svg" />
                  <img v-if="o.oStatus == 2" class="icon_status" src="@/assets/paper/circle_wrong.svg" />
                  <img v-if="o.oStatus == 3" class="icon_status" src="@/assets/paper/circle_default.svg" />
                </div>
                <span v-if="i.questionType == 1" class="letters font16">{{ map.letter[oIndex] }}、</span>
                <div class="optionContent font16" v-html="o.optionContent" />
              </div>
            </template>
            <template v-else>
              <el-radio-group v-model="map.value1[index]" class="radios_group6" @change="
                radioChange1(map.value1[index], index, i.questionType, i.questionId)
                ">
                <div v-for="(o, oIndex) in i.optionList" :key="oIndex" class="answer_radio">
                  <el-radio :label="o.id">
                    <div class="radio_item">
                      <div v-if="i.questionType == 1" class="letters font16">
                        {{ map.letter[oIndex] }}、
                      </div>
                      <div v-html="o.optionContent" />
                    </div>
                  </el-radio>
                </div>
              </el-radio-group>
            </template>
          </div>
          <div v-if="i.questionType == 4 && !isAnalysis">
            <div class="problemTitleZi font16 mgb10">
              <span>({{ index + 1 }})、</span>
              <div v-html="i.questionTitle" />
            </div>
            <el-input v-for="oIndex in i.optionCount" :key="oIndex" v-model="map.valueList[oIndex - 1]"
              :placeholder="'请输入第' + oIndex + '个空的答案'" style="margin-bottom: 10px" size="large"
              @blur="handleSaveProblem" />
            <el-button v-if="isShowConfirm" color="#2256F6" style="color: white" size="large"
              :style="submitStatus ? { opacity: '0.8' } : { opacity: '1' }" @click="radioChange(-1)">
              提交
            </el-button>
          </div>
          <div v-if="i.questionType == 5 && !isAnalysis">
            <div class="problemTitle font16 mgb10">
              <span>({{ index + 1 }})、</span>
              <div v-html="i.questionTitle" />
            </div>
            <el-input v-model="map.value2[index]" color="#2256F6" type="textarea" placeholder="请输入答案" class="mgb10"
              resize="none" :rows="7" @blur="
                handleSaveProblem1(map.value2[index], index, i.questionType, i.questionId)
                " />
            <el-button v-if="isShowConfirm" color="#2256F6" style="color: white" size="large"
              :style="submitStatus ? { opacity: '0.8' } : { opacity: '1' }" @click="
                radioChange2(map.value2[index], index, i.questionType, i.questionId)
                ">
              提交
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="problem.questionType == 7">
      <div class="font16 mgb20">
        <span>{{ index + 1 }}、</span>
        <div v-html="processString(problem.questionTitle)" v-if="problem.questionTitle"></div>
      </div>
      <div class="problemItem6" v-if="isAnalysis" v-show="false">
        <div v-for="(i, index) in problem.adminSubQuestionResps" :key="index" class="qusitionStyle7">
          <div class="problemTitle7 font16 mgb5">
            <span>({{ index + 1 }})、</span>
          </div>
          <div>
            <template v-if="isAnalysis || i.show">
              <!-- <div style="display: flex"> -->
              <div v-for="(o, oIndex) in i.optionList" :key="oIndex" class="oList7">
                <div class="item_status">
                  <img v-if="o.oStatus == 1" class="icon_status" src="@/assets/paper/circle_correct.svg" />
                  <img v-if="o.oStatus == 2" class="icon_status" src="@/assets/paper/circle_wrong.svg" />
                  <img v-if="o.oStatus == 3" class="icon_status" src="@/assets/paper/circle_default.svg" />
                </div>
                <span v-if="i.questionType == 1" class="letters font16">{{ map.letter[oIndex] }}、</span>
                <div class="optionContent font16" v-html="o.optionContent" />
              </div>
              <!-- </div> -->
            </template>
            <template v-else>
              <el-radio-group v-model="map.value1[index]" class="radios_group7" @change="
                radioChange1(map.value1[index], index, i.questionType, i.questionId)
                ">
                <div v-for="(o, oIndex) in i.optionList" :key="oIndex" class="answer_radio7">
                  <el-radio :label="o.id">
                    <div class="radio_item">
                      <div v-if="i.questionType == 1" class="letters font16">
                        {{ map.letter[oIndex] }}、
                      </div>
                      <div v-html="o.optionContent" />
                    </div>
                  </el-radio>
                </div>
              </el-radio-group>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, toRefs, reactive } from "vue";
import { useUserStore } from "@/stores/user";
import { ElMessage, ElMessageBox } from "element-plus";
import { smartFixHtml } from "@/utils/htmlUtils";
import { getSession } from "@/utils/storage";
import {
  practiceTitleAnswerSave,
  practiceTitleSave,
  paperAnswerSave,
  practiceAnswerSave,
} from "@/api/paper.js";
export default defineComponent({
  props: {
    problem: {
      type: Object,
      default() {
        return {};
      },
    },
    titleId: {
      type: String,
      default() {
        return "";
      },
    },
    recordId: {
      type: String,
      default() {
        return "";
      },
    },
    titleRecordId: {
      type: String,
      default() {
        return "";
      },
    },
    index: {
      type: Number,
      default() {
        return 0;
      },
    },
    isAnalysis: {
      type: Boolean,
      default() {
        return false;
      },
    },
    showAnswerInfo: {
      type: String,
      default() {
        return "1";
      },
    },
    courseId: {
      type: String,
      default: "",
    },
    questionType: {
      type: Number,
      default: 2,
    },
    isShowConfirm: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    const {
      problem,
      recordId,
      titleRecordId,
      courseId,
      questionType,
      isShowConfirm,
    } = toRefs(props);
    const submitStatus = ref(false)
    const map = reactive({
      letter: "ABCDEFGHIJkLMNOPQRSTUVWXYZ".split(""),
      value: "",
      value1: [],
      value2: [],
      valueList: [],
      uploadList: [],
      materialType: "-1",
    });
    const store = useUserStore();
    const { getToken } = store;
    const token = computed(() => {
      return getToken();
    });
    const handleSaveProblem = () => {
      if (!isShowConfirm.value) {
        submit();
      }
    };
    const handleSaveProblem1 = (e, index, questionType, questionId) => {
      if (!isShowConfirm.value) {
        submit({ value: map.value2[index], questionType, questionId });
      }
    };
    const checkboxChange = (e) => {
      if (e != -1) {
        map.valueList = e;
      }
      if (!isShowConfirm.value) {
        submit();
      }
    };
    const checkboxChange1 = (e, index, questionType, questionId) => {
      if (e != -1) {
        map.valueList = e;
      }
      if (!isShowConfirm.value) {
        submit({ value: map.valueList, questionType, questionId });
      }
    };
    const radioChange = (e) => {
      if (e != -1) {
        map.value = e;
      }
      submit();
    };
    const radioChange1 = (e, index, questionType, questionId) => {
      if (e != -1) {
        map.value1[index] = e;
      }
      submit({ value: map.value1[index], questionType, questionId });
    };
    const radioChange2 = (e, index, questionType, questionId) => {
      if (e != -1) {
        map.value2[index] = e;
      }
      submit({ value: map.value2[index], questionType, questionId });
    };
    const submit = (value) => {
      submitStatus.value = false;
      if (isShowConfirm.value) {
        if (
          problem.value.questionType === 2 &&
          (!map.valueList ||
            map.valueList.length === 0 ||
            map.valueList.every((val) => {
              return !val;
            }))
        ) {
          ElMessage.error("请先回答问题");
          return;
        }
        if (problem.value.questionType === 5 && !map.value) {
          ElMessage.error("请先回答问题");
          return;
        }
      }
      const d = {
        questionId: problem.value.id,
        practiceTitleRecordId: titleRecordId.value,
        practiceId: courseId.value,
        userAnswer: "",
      };
      if (problem.value.questionType === 6 || problem.value.questionType === 7) {
        d.questionId = value.questionId;
      }
      if (problem.value.questionType === 2 || problem.value.questionType === 4) {
        d.userAnswer = map.valueList.join("|");
      } else {
        d.userAnswer = value ? value.value : map.value;
      }
      // if (problem.value.questionType === 7) {
      //   d.userAnswer = value.value;
      // }
      // if (problem.value.questionType === 6) {
      //   if (value.questionType === 1) {
      //     d.userAnswer = value.value;
      //   } else if (value.questionType === 2) {
      //     d.userAnswer = value.value.join("|");
      //   }
      // }
      emit("updateUserAnswer", d);
      if (questionType.value !== 4) {
        d.practiceRecordId = recordId.value;
        practiceTitleAnswerSave(d)
          .then((res) => {
            submitStatus.value = true;
            ElMessage.success("提交成功");
          })
          .catch((e) => {
            // ElMessage.error(e)
          });
      } else {
        practiceTitleSave(d)
          .then((res) => {
            submitStatus.value = true;
            ElMessage.success("提交成功");
          })
          .catch((e) => {
            // ElMessage.error(e)
          });
      }
    };
    let selectList = [];
    let selectOption = [];
    const listArray = ref([]);
    const getTextWidth = (text) => {
      // 创建一个临时的span元素
      var span = document.createElement("span");
      span.style.visibility = "hidden"; // 隐藏元素
      span.style.whiteSpace = "nowrap"; // 防止文本换行
      span.style.position = "absolute"; // 定位元素
      span.style.left = "-9999px"; // 将元素移出可视区域
      span.textContent = text; // 设置文本内容

      // 将span元素添加到文档中
      document.body.appendChild(span);

      // 获取span元素的宽度
      var width = span.offsetWidth;

      // 移除span元素
      document.body.removeChild(span);

      return width;
    };
    onMounted(() => {
      if (problem.value.userAnswer && (problem.value.questionType == 2 || problem.value.questionType == 4)) {
        submitStatus.value = true
      } else {
        submitStatus.value = false
      }
      if (problem.value.questionType == 7) {
        const selects = document.querySelectorAll("select");
        // 为每个<select>元素添加change事件监听器
        selects.forEach((select, index) => {
          for (var i = 0; i < select.options.length; i++) {
            if (select.options[i].selected) {
              // console.log(select.options[i].text);
              var textWidth = getTextWidth(select.options[i].text);
              select.style.width = textWidth > 260 ? textWidth + 100 + 'px' : textWidth + 60 + 'px'
            }
          }
          select.addEventListener("change", (event) => {
            var selectedIndex = select.selectedIndex;
            // 处理change事件
            const selectedOption = select.options[select.selectedIndex];
            const info = selectedOption.dataset.info;
            const d = {
              practiceId: courseId.value,
              practiceRecordId: recordId.value,
              practiceTitleRecordId: titleRecordId.value,
              questionId: event.target.selectedOptions[0].id,
              userAnswer: event.target.value,
            };
            var textWidth = getTextWidth(select.options[selectedIndex].text);
            select.style.width =
              textWidth > 260 ? textWidth + 100 + "px" : textWidth + 60 + "px";
            if (info == problem.value.practiceQuestionId) {

              if (!props.isAnalysis) {
                if (d.questionId) {
                  practiceTitleAnswerSave(d);
                  emit("updateUserAnswer", d);
                }
              }
            }
          });
        });
      }
      if (problem.value.userAnswer) {
        map.value = problem.value.userAnswer;
      }
      if (problem.value.userAnswer && problem.value.userAnswer.split("|").length > 0) {
        map.valueList = problem.value.userAnswer.split("|");
      }
      // 题冒题的子题的答案
      if (problem.value.questionType == 6) {
        let isShow = "";
        map.value1 = [];
        problem.value.adminSubQuestionResps.forEach((item) => {
          if (item.questionType == 1 || item.questionType == 2) {
            problem.value.isShow = 1;
          }
          map.value1.push(item.userAnswer ? item.userAnswer : "");
        });
        return isShow;
      }
    });

    // 获取正确答案的格式化显示
    const getCorrectAnswerDisplay = (subQuestion) => {
      if (!subQuestion.questionAnswer) {
        return '';
      }
      if (subQuestion.questionType === 1) {
        // 单选题：找到正确答案对应的选项字母和内容
        if (subQuestion.optionList) {
          let correctOption = null;
          let optionIndex = null;
          subQuestion.optionList.forEach((el, i) => {
            if (el.optionContent === subQuestion.questionAnswer && correctOption === null) {
              correctOption = el;
              optionIndex = i;
            }
          });
          if (correctOption && optionIndex !== null) {
            // 返回 "A. 选项内容" 格式，保留 HTML 标签以便 v-html 渲染
            let optionContent = correctOption.optionContent;
            // 移除可能导致布局问题的标签，但保留其他格式
            optionContent = optionContent.replace(/<\/?p>/g, '').trim();
            return `${map.letter[optionIndex]}. ${optionContent}`;
          }
          return subQuestion.questionAnswer;
        }
        return subQuestion.questionAnswer;
      } else if (subQuestion.questionType === 2) {
        // 多选题：返回多个选项字母和内容
        if (subQuestion.optionList) {
          const correctOptions = [];
          subQuestion.optionList.forEach((el, i) => {
            if (subQuestion.questionAnswer.indexOf(el.optionContent) > -1) {
              let optionContent = el.optionContent;
              // 移除可能导致布局问题的标签，但保留其他格式
              optionContent = optionContent.replace(/<\/?p>/g, '').trim();
              correctOptions.push(`${map.letter[i]}. ${optionContent}`);
            }
          });
          return correctOptions.join('；');
        }
        return subQuestion.questionAnswer;
      } else if (subQuestion.questionType === 3) {
        // 判断题
        return subQuestion.questionAnswer;
      } else if (subQuestion.questionType === 4) {
        // 填空题
        const arr = subQuestion.questionAnswer.split('|');
        return arr.join('；');
      } else {
        return subQuestion.questionAnswer;
      }
    };

    // 处理完型填空下拉框
    const processString = (str) => {
      if (props.isAnalysis && str) {
        // 背题模式：将 {1}, {2}, {3} 等占位符替换为正确答案
        if (problem.value.adminSubQuestionResps && problem.value.adminSubQuestionResps.length > 0) {
          let regex = /{\s*([0-9]+)\s*}/g;
          // 创建一个映射，存储每个数字对应的正确答案
          const answerMap = new Map();
          
          // 先收集所有需要替换的答案
          problem.value.adminSubQuestionResps.forEach((subQuestion, index) => {
            const correctAnswer = getCorrectAnswerDisplay(subQuestion);
            if (correctAnswer) {
              answerMap.set(index + 1, correctAnswer); // 使用题目编号（从1开始）作为key
            }
          });
          
          // 替换所有占位符
          str = str.replace(regex, (match, numStr) => {
            const num = Number(numStr);
            if (answerMap.has(num)) {
              const correctAnswer = answerMap.get(num);
              return `<span style="color: #3d7fff; font-weight: bold; border-bottom: 2px solid #3d7fff; padding: 0 4px; display: inline-block; max-width: 100%; word-break: break-word;">${correctAnswer}</span>`;
            }
            return match; // 如果没有找到对应的答案，保持原样
          });
        }
        return str;
      }
      if (str) {
        listArray.value = problem.value.adminSubQuestionResps;
        for (let i = 0; i < listArray.value.length; i++) {
          selectList.push([]);
        }
        listArray.value.map((item, index) => {
          item.optionList.map((item1, index1) => {
            if (item.questionId == item1.questionId) {
              if (item.userAnswer == item1.id) {
                selectList[index].push(`
                <option style="text-align: left;margin: 5px;" value="${item1.id}" selected data-info=${problem.value.practiceQuestionId} id=${item.questionId} >
                  ${map.letter[index1]}、 ${item1.optionContent.replace(/<\/?p>/g, '')}
                  </option>
                `)
              } else {
                selectList[index].push(`
                <option style="text-align: left;margin: 5px;" value="${item1.id}" data-info=${problem.value.practiceQuestionId} id=${item.questionId} >
                  ${map.letter[index1]}、 ${item1.optionContent.replace(/<\/?p>/g, '')}
                  </option>
                `)
              }

            }
          });
        });
        // const regex1 = /<u>(.*?)<\/u>/g;
        // str = str.replace(regex1, (match, p1) => `<u>${p1.replace(/&nbsp;/g, "")}</u>`);

        // let regex = /<u>\s*([0-9]+)\s*<\/u>/g;
        let regex = /{\s*([0-9]+)\s*}/g;
        let arr = str.match(regex);
        selectList.map((item, index) => {
          let str1 = item.join(``);
          let a = ref(`<option style="color:#ccc;display:none">${index + 1}</option>`);
          let obj = a.value + str1;
          selectOption.push(obj);
        });
        if (!arr) return str;
        let arrNum = arr.map((item) => {
          // let i = Number(item.substr(1, item.length - 2)) - 1
          // let ss = item.replace(/<\/?u>/g, "");
          let ss = item.replace(/[{}]/g, '')
          let i = Number(ss);
          str = str.replace(
            item,
            `<select class="mySelect" style="border-bottom: 2px solid #2ba3ff;text-align: center;width:100px;font-size:16px">
          ${selectOption[i - 1]}
        </select>`
          );
        });
        return str;
      }
    };
    return {
      map,
      checkboxChange,
      checkboxChange1,
      handleSaveProblem,
      handleSaveProblem1,
      radioChange,
      radioChange1,
      radioChange2,
      submitStatus,
      submit,
      processString,
      smartFixHtml,
    };
  },
});
</script>

<style lang="scss" scoped>
.problemTitle {
  display: flex;
  padding-right: 60px;

  div {
    &:nth-child(1) {
      width: 18px;
    }
  }
}

.problemTitle6 {
  display: flex;
  flex-wrap: wrap;
  max-height: 350px;
  overflow: auto;
  scrollbar-width: thin; //滚动条的样式

  div {
    &:nth-child(1) {
      width: 18px;
    }
  }
}

.problemTitleZi {
  display: flex;

  div {
    &:nth-child(1) {
      width: 18px;
    }
  }
}

.problemTitle7 {
  display: flex;
  flex-direction: column;

  div {
    &:nth-child(1) {
      width: 18px;
    }
  }
}

.problemItem {
  display: flex;
}

.problemItem6 {
  // display: flex;
  flex-wrap: wrap;
  max-height: 320px;
  overflow: auto;
  scrollbar-width: thin; //滚动条的样式
}

.qusitionStyle6 {
  margin: 15px 35px 0 35px;
}

.qusitionStyle7 {
  display: flex;
  // justify-content: center;
  align-items: center;
  margin: 20px 0 0 35px;
}

.radios_group {
  flex-direction: column;
  align-items: flex-start;
  row-gap: 20px;
}

.radios_group6 {
  flex-direction: column;
  align-items: flex-start;
  row-gap: 5px;
}

.radios_group7 {
  flex-direction: row;
  align-items: flex-start;
  row-gap: 5px;
  // width: 150%;
}

:deep(.answer_radio .el-radio) {
  display: block;
  height: fit-content;
}

:deep(.answer_radio7 .el-radio) {
  display: block;
  height: fit-content;
  margin-right: 30px;
}

:deep(.el-radio.el-radio--small .el-radio__label) {
  font-size: 16px;
  display: inline-block;
  white-space: pre-wrap;
}

:deep(.el-radio__input.is-checked + .el-radio__label) {
  color: #333;
}

:deep(.el-radio.is-checked) .letters.border {
  background: #3d7fff;
  color: #ffffff;
}

:deep(.el-radio .el-radio__inner) {
  height: 16px;
  width: 16px;
}

:deep(.hide .el-radio .el-radio__input) {
  vertical-align: text-top;
  display: none;
}

.radio_item {
  display: flex;
}

:deep(.answer_checkbox .el-checkbox) {
  display: flex;
  align-items: baseline;
  height: fit-content;
  margin-bottom: 24px;
}

:deep(.answer_checkbox6 .el-checkbox) {
  display: flex;
  align-items: center;
  height: fit-content;
  margin-bottom: 10px;
}

:deep(.el-checkbox.el-checkbox--small .el-checkbox__label) {
  font-size: 16px;
  white-space: pre-wrap;
}

:deep(.el-checkbox .el-checkbox__inner) {
  height: 16px;
  width: 16px;
}

:deep(.el-checkbox .el-checkbox__input) {
  //display: none;
}

:deep(.el-checkbox__input.is-checked + .el-checkbox__label) {
  color: #333;
}

:deep(.el-checkbox.is-checked) .letters.border {
  background: #3d7fff;
  color: #ffffff;
}

:deep(.el-checkbox.el-checkbox--small .el-checkbox__inner:after) {
  height: 8px;
  width: 4px;
}

.checkbox_item {
  display: flex;
  align-items: baseline;

  div {
    display: inline-block;
  }
}

.oList {
  padding-left: 1px;
  margin-bottom: 20px;
  display: flex;

  .item_status {
    height: 14px;
  }

  .icon_status {
    min-width: 20px;
    height: 20px;
    margin-right: 7px;
    margin-top: 2px;
  }
}

.oList6 {
  padding-left: 1px;
  margin-bottom: 5px;
  display: flex;

  .item_status {
    height: 14px;
  }

  .icon_status {
    min-width: 20px;
    height: 20px;
    margin-right: 7px;
    margin-top: 2px;
  }
}

.oList7 {
  display: flex !important;
  margin-right: 30px;
  flex-direction: row;
  align-items: flex-start;

  .item_status {
    height: 14px;
  }

  .icon_status {
    min-width: 20px;
    height: 20px;
    margin-right: 7px;
    margin-top: 2px;
  }
}

.letters.border {
  border: 1px solid #d9d9d9;
  border-radius: 25px;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 23px;
  min-width: 21px;
  margin-right: 8px;
}

//单选、多选按钮样式修改
:deep(.el-radio .el-radio__inner) {
  height: 20px;
  width: 20px;
  background: #fff;
}

:deep(.el-radio__inner:hover) {
  border-color: #666;
}

:deep(.el-radio__input.is-checked .el-radio__inner) {
  border-color: #666;
  background: #fff;
}

:deep(.el-radio__input.is-checked .el-radio__inner:after) {
  transform: scale(1);
}

:deep(.el-radio__inner:after) {
  width: 10px;
  height: 10px;
  top: 50%;
  left: 50%;
  background: #666;
  transition: none;
}

:deep(.el-checkbox .el-checkbox__inner) {
  height: 20px;
  width: 20px;
  background: #fff;
}

:deep(.answer_checkbox .el-checkbox) {
  align-items: flex-start;
}

:deep(.el-checkbox__inner:after) {
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  transition: none;
}

:deep(.el-checkbox.el-checkbox--small .el-checkbox__inner:after) {
  height: 8px;
  width: 8px;
}

:deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
  background: #fff;
  border-color: #666;
}

:deep(.el-checkbox__input.is-checked .el-checkbox__inner:after) {
  border: 1px solid #666;
  background: #666;
  transform: none;
}

:deep(.el-checkbox__inner:hover) {
  border-color: #666;
}
</style>
